export default function IconDashboard({
  color = 'currentColor',
  width = 24,
  height = 24,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7 2H4.5C3.11929 2 2 3.11929 2 4.5V5.75C2 7.13071 3.11929 8.25 4.5 8.25H7C8.38071 8.25 9.5 7.13071 9.5 5.75V4.5C9.5 3.11929 8.38071 2 7 2Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7 13.25H4.5C3.11929 13.25 2 14.3693 2 15.75V19.5C2 20.8807 3.11929 22 4.5 22H7C8.38071 22 9.5 20.8807 9.5 19.5V15.75C9.5 14.3693 8.38071 13.25 7 13.25Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.5 2H17C15.6193 2 14.5 3.11929 14.5 4.5V8.25C14.5 9.63071 15.6193 10.75 17 10.75H19.5C20.8807 10.75 22 9.63071 22 8.25V4.5C22 3.11929 20.8807 2 19.5 2Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.5 15.75H17C15.6193 15.75 14.5 16.8693 14.5 18.25V19.5C14.5 20.8807 15.6193 22 17 22H19.5C20.8807 22 22 20.8807 22 19.5V18.25C22 16.8693 20.8807 15.75 19.5 15.75Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
